import { createContext, useState } from "react"

const LoaderContext = createContext({
    loader: false,
    message: '',
    setLoader: (loading: boolean, message?: string) => {},
    getLoader: (): boolean => false
});

const LoaderContextProvider = ({children}: any) => {
    const [loader, setLoaderFn] = useState(false)
    const [message, setMessage] = useState('')

    const setLoader = (loading: boolean, message: string = 'Loading...') => {
        setLoaderFn(loading)
        setMessage(message)
    }

    const getLoader = () => {
        return loader;
    }

    return <LoaderContext.Provider value={{loader: loader, message: message, setLoader: setLoader, getLoader}}>{children}</LoaderContext.Provider>
}

export {LoaderContextProvider, LoaderContext}